import React from 'react';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import TermsSection from './TermsSection';
import { useNavigate } from 'react-router-dom';
import SEO from '../../components/common/SEO';

const GeneralTerms3 = () => {
  const navigate = useNavigate();

  const handlePrevious = () => {
    navigate('/general-terms/page/2');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const conditionGeneralList3 = [
    {
      title: 'Subcontracting',
      para: 'We reserve the right to subcontract all or part of the services covered by these terms, provided that we remain responsible for their proper execution.',
    },
    {
      title: 'Force Majeure',
      para: 'Neither party shall be liable for any delay or failure to perform its obligations under these terms due to circumstances beyond its reasonable control, including but not limited to natural disasters, government actions, labor disputes, or other unforeseeable events.',
    },
    {
      title: 'Environment',
      para: 'Our company is registered with ADEME (French Environment and Energy Management Agency) under unique identifiers (IDU).',
    },
    {
      title: 'Personal Data',
      para: 'Data controller: ELIXIR. Data is processed for commercial management, handling unpaid invoices, accounting, legal claims, and commercial prospecting (based on consent or legitimate interest). Data may be shared with service providers, legal authorities, and transport or banking services. Data is stored only as long as necessary to fulfill these purposes and in compliance with commercial legal retention rules. You have the right to access, rectify, delete, or port your data, limit its processing, object to processing for legitimate reasons, and withdraw your consent at any time. You can exercise these rights by writing to ELIXIR, 6 PLACE DU PRESIDENT THOMAS WOODROW WILSON, 31000 TOULOUSE.',
    },
    {
      title: 'Electronic Contract',
      para: 'In case of contract conclusion via electronic means, the parties expressly agree not to apply paragraphs 1° and 5° of Article 1127-1 of the French Civil Code, and Article 1127-2, in accordance with Article 1127-3 paragraph 2.',
    },
    {
      title: 'References',
      para: "We are authorized to use and reproduce the client's name, logo, and brand on any promotional material as a commercial reference. To this end, the client grants us a worldwide, non-exclusive, non-transferable, royalty-free, and revocable license, valid for the duration of the intellectual property rights' protection.",
    },
    {
      title: 'Severability',
      para: 'If any provision of the GTC is declared null or deemed unwritten, this shall not affect the validity of the remaining provisions. The parties agree to negotiate in good faith to replace the invalid provision with a clause that most closely reflects the intended effect.',
    },
    {
      title: 'Assignment',
      para: 'The client may not assign or transfer their rights or obligations under these terms without prior written consent from ELIXIR. Any unauthorized transfer shall be null. We may freely assign the agreement to any third party by notifying the client via registered letter.',
    },
    {
      title: 'Limitation Period',
      para: 'By derogation from Article L110-4 of the French Commercial Code, any claim by the client shall be inadmissible if submitted more than one year after the order date.',
    },
    {
      title: 'Governing Law',
      para: 'These terms and conditions are governed by French law.',
    },
    {
      title: 'Mediation',
      para: "Any disputes relating to the validity, interpretation, performance, non-performance, suspension, or termination of this contract shall be submitted, at the parties' discretion: to mediation in accordance with the CMAP mediation rules (to which both parties declare adherence); to the business mediator; or to any other mediation center or mediator approved by both parties. Mediator fees will be shared equally by the parties.",
    },
    {
      title: 'Jurisdiction',
      para: 'Any dispute between the parties concerning the validity, interpretation, or execution of these terms shall fall under the exclusive jurisdiction of the Commercial Court of Toulouse, unless mandatory legal provisions state otherwise.',
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="General Terms and Conditions - Page 3"
        description="Final terms and conditions for Elixir honey products. Learn about data protection, governing law, mediation, and jurisdiction."
        keywords="Elixir data protection, honey terms governing law, Elixir mediation terms, honey jurisdiction terms"
      />
      <Header />
      <div className="bg-[#f7fbff] py-16">
        <div className="container mx-auto px-4 text-center">
        <h1 className="text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-[#d4af37] mb-6">
           GENERAL TERMS AND CONDITIONS
          </h1>
          <p className="text-base sm:text-base md:text-xl lg:text-2xl text-[#475467] max-w-3xl mx-auto">
            Here we detail important legal provisions including limitations of liability,
            subcontracting, governing law, and procedures for dispute resolution to protect all
            parties involved.
          </p>
        </div>
      </div>

      <main className="flex-grow bg-white py-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <TermsSection>
            {conditionGeneralList3.map((item, index) => (
              <p className="mt-4" key={index}>
                <b>{item.title} : </b>
                {item.para}
              </p>
            ))}
          </TermsSection>

          <div className="flex justify-center mt-4">
            <button
              onClick={handlePrevious}
              className="px-6 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition"
            >
              Previous Page
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default GeneralTerms3;
